const config = {
  REGION: "ap-southeast-2",
  BUCKET: "pg-preprod-file-gateway",
  USER_POOL_ID: "ap-southeast-2_Ao56HVlhV",
  USER_POOL_APP_CLIENT_ID: "3f7f7n5e1so0ccp5pm1ee5q1vt",
  USER_POOL_DOMAIN: "https://preprod-nonprod-idp-filegateway-pg.auth.ap-southeast-2.amazoncognito.com",
  IDENTITY_POOL_ID: "ap-southeast-2:fadfe77f-f8b0-4adb-8d2e-629ce7301eba",
};

export default config;
